export const normalKeys = [
  {
    key: 'city',
    value: '城市',
    len: [2, 4]
  },
  {
    key: 'gender',
    value: '性别',
    len: [1, 2]
  },
  {
    key: 'week',
    value: '星期',
    len: [3, 3]
  },
  {
    key: 'day',
    value: '日期',
    len: [4, 6]
  }
]

export const defaultSiteSet = [
  'SITE_SET_TENCENT_VIDEO',
  'SITE_SET_QQ_MUSIC_GAME',
  'SITE_SET_KANDIAN',
  'SITE_SET_TENCENT_NEWS',
  'SITE_SET_MOBILE_UNION'
]

export const buttonTextList = [
  {
    value: 'MORE_INFO',
    label: '了解更多'
  },
  {
    label: '立即下载',
    value: 'DOWNLOAD_NOW'
  },
  {
    value: 'TRY_PLAY_NOW',
    label: '立即试玩'
  },
  {
    label: '下载应用',
    value: 'DOWNLOAD_APP'
  },
  {
    value: 'ENTER_MINI_GAME',
    label: '进入小游戏'
  },
  {
    value: 'TRY_NOW',
    label: '立即体验'
  },
  {
    value: 'OPEN_MINI_GAME',
    label: '打开游戏'
  },
  {
    value: 'PLAY_NOW',
    label: '立即玩'
  },
  {
    label: '下载游戏',
    value: 'DOWNLOAD_GAME'
  },
  {
    label: '立即安装',
    value: 'INSTALL_NOW'
  },
  {
    value: 'RESERVE_NOW',
    label: '立即预约'
  }
]

export const conversionTarget = [
  {
    value: 'CONVERSION_TARGET_GET',
    label: '领取'
  },
  {
    value: 'CONVERSION_TARGET_RESERVE',
    label: '预约'
  },
  {
    value: 'CONVERSION_TARGET_APPLY',
    label: '申请'
  }
]

export const faceKeys = [
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/smiley_0.png',
    label: '[微笑]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/smiley_1.png',
    label: '[撇嘴]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/smiley_2.png',
    label: '[色]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/smiley_3.png',
    label: '[发呆]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/smiley_5.png',
    label: '[流泪]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/smiley_6.png',
    label: '[害羞]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/smiley_8.png',
    label: '[睡]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/smiley_9.png',
    label: '[大哭]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/smiley_10.png',
    label: '[尴尬]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/smiley_11.png',
    label: '[发怒]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/smiley_12.png',
    label: '[调皮]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/smiley_13.png',
    label: '[呲牙]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/smiley_14.png',
    label: '[惊讶]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/smiley_15.png',
    label: '[难过]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/smiley_17.png',
    label: '[冷汗]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/smiley_18.png',
    label: '[抓狂]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/smiley_20.png',
    label: '[偷笑]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/smiley_21.png',
    label: '[愉快]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/smiley_22.png',
    label: '[白眼]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/smiley_23.png',
    label: '[傲慢]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/smiley_26.png',
    label: '[惊恐]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/smiley_27.png',
    label: '[流汗]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/smiley_28.png',
    label: '[憨笑]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/smiley_30.png',
    label: '[奋斗]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/smiley_32.png',
    label: '[疑问]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/smiley_34.png',
    label: '[晕]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/smiley_36.png',
    label: '[衰]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/smiley_38.png',
    label: '[敲打]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/smiley_39.png',
    label: '[再见]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/smiley_40.png',
    label: '[擦汗]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/smiley_42.png',
    label: '[鼓掌]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/smiley_44.png',
    label: '[坏笑]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/smiley_45.png',
    label: '[左哼哼]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/smiley_46.png',
    label: '[右哼哼]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/smiley_47.png',
    label: '[哈欠]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/smiley_49.png',
    label: '[委屈]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/smiley_50.png',
    label: '[快哭了]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/smiley_51.png',
    label: '[阴险]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/smiley_52.png',
    label: '[亲亲]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/smiley_54.png',
    label: '[可怜]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/smiley_56.png',
    label: '[西瓜]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/smiley_60.png',
    label: '[咖啡]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/smiley_62.png',
    label: '[猪头]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/smiley_63.png',
    label: '[玫瑰]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/smiley_65.png',
    label: '[嘴唇]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/smiley_66.png',
    label: '[爱心]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/smiley_68.png',
    label: '[蛋糕]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/smiley_75.png',
    label: '[月亮]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/smiley_76.png',
    label: '[太阳]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/smiley_78.png',
    label: '[拥抱]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/smiley_79.png',
    label: '[强]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/smiley_81.png',
    label: '[握手]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/smiley_82.png',
    label: '[胜利]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/smiley_83.png',
    label: '[抱拳]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/smiley_84.png',
    label: '[勾引]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/smiley_85.png',
    label: '[拳头]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/smiley_89.png',
    label: '[OK]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/smiley_92.png',
    label: '[跳跳]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/smiley_93.png',
    label: '[发抖]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/smiley_94.png',
    label: '[怄火]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/smiley_95.png',
    label: '[转圈]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/2_04.png',
    label: '[嘿哈]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/2_05.png',
    label: '[捂脸]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/2_02.png',
    label: '[奸笑]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/2_06.png',
    label: '[机智]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/2_12.png',
    label: '[皱眉]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/2_11.png',
    label: '[耶]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/2_20.png',
    label: '[加油]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/2_21.png',
    label: '[汗]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/2_22.png',
    label: '[天啊]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/2_23.png',
    label: '[社会社会]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/2_24.png',
    label: '[旺柴]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/2_25.png',
    label: '[好的]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/2_26.png',
    label: '[加油加油]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/2_27.png',
    label: '[哇]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/2_09.png',
    label: '[红包]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/2_16.png',
    label: '[發]'
  },
  {
    url: 'https://wxa.wxs.qq.com/wxad-design/emojis/2_15.png',
    label: '[福]'
  }
]

export const cardTemplateIds = [450, 452, 588, 589, 955, 957]
export const multTemplateIds = [311, 641, 642, 643, 721, 618, 1480, 1465, 1064]
